import React from 'react';
import { Link } from 'react-router-dom';

export default function LandingPage() {
  return (
    <div style={{ 
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* شريط التنقل */}
      <nav style={{ 
        backgroundColor: '#1e40af',
        padding: '16px 24px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto', 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center' 
        }}>
          <div style={{ color: 'white', fontSize: '28px', fontWeight: 'bold' }}>
            TradeAH
          </div>
          <div style={{ color: 'white', fontSize: '16px' }}>
            أعظم عقل مالي عربي
          </div>
        </div>
      </nav>

      {/* المحتوى الرئيسي */}
      <div style={{ 
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <div style={{ 
          maxWidth: '800px',
          textAlign: 'center',
          backgroundColor: 'white',
          padding: '60px 40px',
          borderRadius: '24px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.15)'
        }}>
          {/* الشعار */}
          <div style={{ 
            fontSize: '64px',
            marginBottom: '24px',
            color: '#1e40af'
          }}>
            📈
          </div>
          
          {/* العنوان الرئيسي */}
          <h1 style={{ 
            fontSize: '48px',
            fontWeight: '800',
            color: '#0f172a',
            marginBottom: '16px',
            lineHeight: '1.2'
          }}>
            TradeAH V2
          </h1>
          
          {/* الوصف */}
          <p style={{ 
            fontSize: '20px',
            color: '#64748b',
            marginBottom: '40px',
            lineHeight: '1.6'
          }}>
            منصة تحليل مالي ذكية تدمج بين الخبرة البشرية والذكاء الآلي  
            لتقديم توصيات استثمارية دقيقة في جميع الأسواق العربية والعالمية
          </p>
          
          {/* مزايا النظام */}
          <div style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '20px',
            marginBottom: '40px'
          }}>
            <div style={{ 
              padding: '20px',
              backgroundColor: '#f0f9ff',
              borderRadius: '16px',
              border: '1px solid #bae6fd'
            }}>
              <div style={{ fontSize: '24px', marginBottom: '12px', color: '#1e40af' }}>🤖</div>
              <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: '700', color: '#0f172a' }}>
                تحليل ذكي
              </h3>
              <p style={{ margin: 0, fontSize: '14px', color: '#64748b' }}>
                خوارزميات متطورة لاكتشاف الفرص
              </p>
            </div>
            
            <div style={{ 
              padding: '20px',
              backgroundColor: '#f0fdf4',
              borderRadius: '16px',
              border: '1px solid #bbf7d0'
            }}>
              <div style={{ fontSize: '24px', marginBottom: '12px', color: '#065f46' }}>👨‍💼</div>
              <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: '700', color: '#0f172a' }}>
                خبراء بشريون
              </h3>
              <p style={{ margin: 0, fontSize: '14px', color: '#64748b' }}>
                توصيات من محللين محترفين
              </p>
            </div>
            
            <div style={{ 
              padding: '20px',
              backgroundColor: '#fff7ed',
              borderRadius: '16px',
              border: '1px solid #fed7aa'
            }}>
              <div style={{ fontSize: '24px', marginBottom: '12px', color: '#c2410c' }}>🌍</div>
              <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: '700', color: '#0f172a' }}>
                جميع الأسواق
              </h3>
              <p style={{ margin: 0, fontSize: '14px', color: '#64748b' }}>
                من البورصة المصرية للأسواق العالمية
              </p>
            </div>
          </div>
          
          {/* أزرار الإجراء */}
          <div style={{ 
            display: 'flex',
            justifyContent: 'center',
            gap: '24px',
            flexWrap: 'wrap'
          }}>
            <Link 
              to="/login"
              style={{
                backgroundColor: '#1e40af',
                color: 'white',
                textDecoration: 'none',
                padding: '16px 40px',
                borderRadius: '16px',
                fontSize: '18px',
                fontWeight: '700',
                boxShadow: '0 4px 12px rgba(30, 64, 175, 0.3)',
                transition: 'transform 0.2s, background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-4px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              تسجيل دخول عميل حالي
            </Link>
            
            <Link 
              to="/signup"
              style={{
                backgroundColor: '#3b82f6',
                color: 'white',
                textDecoration: 'none',
                padding: '16px 40px',
                borderRadius: '16px',
                fontSize: '18px',
                fontWeight: '700',
                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
                transition: 'transform 0.2s, background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-4px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              إنشاء حساب جديد
            </Link>
          </div>
        </div>
      </div>
      
      {/* التذييل */}
      <div style={{ 
        padding: '20px',
        backgroundColor: '#0f172a',
        color: 'white',
        textAlign: 'center'
      }}>
        <div>© {new Date().getFullYear()} TradeAH — جميع الحقوق محفوظة</div>
        <div style={{ marginTop: '8px', fontSize: '14px', opacity: '0.8' }}>
          أعظم عقل مالي عربي
        </div>
      </div>
    </div>
  );
}